export const environment = {
    production: true,
    apiHost: "https://test-api.venduro.io",
    apiPort: "",
    shopApiPath: "shop-api",
    baseHref: "/",
    tokenMethod: "bearer",
    csvExportToken: "h1HfaQGgrUmtI3lg/ROVig==",
    n8nUrl: "https://test-connect.venduro.io/",
};
